module.exports = __webpack_public_path__ + "img/save-post.7b3c322b.png";